module.exports = __webpack_public_path__ + "images/yamaha32d293a11a2c8018b677f447033ab919.png";